// extracted by mini-css-extract-plugin
module.exports = {"root":"InspectionPreview_root__3K9RR","paper":"InspectionPreview_paper__1m1VZ"};